const required = (name: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(
      `Missing ${name}. Set it in .env.local (dev) or the Cloudflare Pages project settings (prod).`,
    );
  }
  return value;
};

/** The Zoom Apps webview blocks fetches to domains missing from the
    Marketplace Domain Allow List. Our own origin is always allowed, so
    inside Zoom every Engine call routes through the same-origin Pages
    proxy (/api/engine → Resolution Engine). */
const inZoomWebview =
  typeof navigator !== 'undefined' && /ZoomApps|ZoomWebKit|ZoomSDK/i.test(navigator.userAgent);

export const env = {
  resolutionEngineBaseUrl: inZoomWebview
    ? '/api/engine'
    : required('VITE_RESOLUTION_ENGINE_BASE_URL', import.meta.env.VITE_RESOLUTION_ENGINE_BASE_URL),
  zoomClientId: required('VITE_ZOOM_CLIENT_ID', import.meta.env.VITE_ZOOM_CLIENT_ID),
  zoomRedirectUri: required('VITE_ZOOM_REDIRECT_URI', import.meta.env.VITE_ZOOM_REDIRECT_URI),
};
